import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-horizontal-align-right",
  templateUrl: "./med-icon-horizontal-align-right.component.html",
})
export class MedIconHorizontalAlignRightComponent extends SvgMixinComponent {}
